import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useMemo, useState } from "react";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import ScienceIcon from "@mui/icons-material/Science";
import { addDoc, collection, doc, getDocs, orderBy, query, updateDoc } from "firebase/firestore";
import { useHistory } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { db } from "../Config/firebase";
import { consultaTenantAtual , aplicarTenantAtual} from "../Utils/tenant";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";

export const COLECAO = "tblGranulometriaAsfalto";

export const PENEIRAS_ASFALTO = [
  { astm: '1 1/2"', abertura: 38.1, tolerancia: null, faixas: { A25: [100, 100] } },
  { astm: '1"', abertura: 25.4, tolerancia: 7, faixas: { A25: [90, 100], B19: [100, 100] } },
  { astm: '3/4"', abertura: 19.1, tolerancia: 7, faixas: { A25: [75, 89], B19: [90, 100], C125: [100, 100] } },
  { astm: '1/2"', abertura: 12.7, tolerancia: 7, faixas: { A25: [58, 78], B19: [70, 89], C125: [90, 100], D95: [100, 100] } },
  { astm: '3/8"', abertura: 9.5, tolerancia: 7, faixas: { A25: [48, 71], B19: [55, 82], C125: [73, 89], D95: [90, 100] } },
  { astm: '1/4"', abertura: 6.3, tolerancia: 7, faixas: { A25: [35, 61], B19: [42, 70], C125: [53, 78], D95: [65, 89] } },
  { astm: "Nº 4", abertura: 4.8, tolerancia: 5, faixas: { A25: [29, 55], B19: [35, 63], C125: [44, 72], D95: [53, 83] } },
  { astm: "Nº 8", abertura: 2.36, tolerancia: 5, faixas: { A25: [19, 45], B19: [23, 49], C125: [28, 58], D95: [32, 67] } },
  { astm: "Nº 16", abertura: 1.18, tolerancia: 5, faixas: { A25: [13, 36], B19: [16, 37], C125: [17, 45], D95: [20, 52] } },
  { astm: "Nº 30", abertura: 0.6, tolerancia: 5, faixas: { A25: [9, 28], B19: [10, 28], C125: [11, 35], D95: [13, 40] } },
  { astm: "Nº 50", abertura: 0.3, tolerancia: 4, faixas: { A25: [5, 21], B19: [6, 20], C125: [6, 25], D95: [8, 29] } },
  { astm: "Nº 100", abertura: 0.15, tolerancia: 3, faixas: { A25: [2, 14], B19: [4, 13], C125: [3, 17], D95: [4, 19] } },
 { astm: "Nº 200", abertura: 0.075, tolerancia: 2, faixas: { A25: [1, 7], B19: [2, 8], C125: [2, 10], D95: [2, 10] } },
{ astm: "Fundo", abertura: null, tolerancia: null, faixas: {} },
];

export const FAIXAS = [
  { id: "A25", label: "A-25" },
  { id: "B19", label: "B-19" },
  { id: "C125", label: "C-12,5" },
  { id: "D95", label: "D-9,5" },
];

export const estadoInicial = {
  codigo: "",
  data: new Date().toISOString().slice(0, 10),
  cliente: "",
  obra: "",
  obraId: "",
  material: "",
  materialId: "",
  codigoMaterial: "",
  procedencia: "",
  localColeta: "",
  operador: "",
  faixa: "C125",
  massaInicialA: "",
  massaInicialB: "",
  granulometria: PENEIRAS_ASFALTO.map((peneira) => ({ astm: peneira.astm, abertura: peneira.abertura, massaA: "", massaB: "" })),
  observacoes: "",
};

export function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return null;
  const texto = String(valor).trim();
  const normalizado = texto.includes(",") ? texto.replace(/\./g, "").replace(",", ".") : texto;
  const n = Number(normalizado);
  return Number.isFinite(n) ? n : null;
}

export function numeroBR(valor, casas = 1) {
  const n = typeof valor === "number" ? valor : numero(valor);
  if (n === null) return "";
  return n.toLocaleString("pt-BR", { minimumFractionDigits: casas, maximumFractionDigits: casas });
}

export function formatarDataBR(data) {
  if (!data) return "-";
  const [ano, mes, dia] = String(data).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : String(data);
}

function textoBusca(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function faixaProjeto(peneira, faixaId) {
  return peneira.faixas[faixaId] || null;
}

export function faixaTrabalho(peneira, faixaId, passanteProjeto) {
  const faixa = faixaProjeto(peneira, faixaId);
  const projeto = numero(passanteProjeto);
  if (!faixa || projeto === null) return faixa;
  if (!peneira.tolerancia) return [projeto, projeto];
  return [
    Math.max(faixa[0], projeto - peneira.tolerancia),
    Math.min(faixa[1], projeto + peneira.tolerancia),
  ];
}

export function recalcularGranulometria(dados) {
  const totalMassaA = (dados.granulometria || []).reduce((total, linha) => total + (numero(linha?.massaA) || 0), 0);
  const totalMassaB = (dados.granulometria || []).reduce((total, linha) => total + (numero(linha?.massaB) || 0), 0);
  let retidaAcumuladaA = 0;
  let retidaAcumuladaB = 0;
  const ajustarZero = (valor) => (valor !== null && Math.abs(valor) < 0.05 ? 0 : valor);

  const granulometria = PENEIRAS_ASFALTO.map((peneira, index) => {
    const linha = dados.granulometria?.[index] || {};
    const massaA = numero(linha.massaA);
    const massaB = numero(linha.massaB);
    const retidaA = massaA !== null && totalMassaA ? (massaA / totalMassaA) * 100 : null;
    const retidaB = massaB !== null && totalMassaB ? (massaB / totalMassaB) * 100 : null;
    if (retidaA !== null) retidaAcumuladaA += retidaA;
    if (retidaB !== null) retidaAcumuladaB += retidaB;
    const passanteA = retidaA !== null ? ajustarZero(100 - retidaAcumuladaA) : null;
    const passanteB = retidaB !== null ? ajustarZero(100 - retidaAcumuladaB) : null;
    const passantes = [passanteA, passanteB].filter((valor) => valor !== null);
    const passante = passantes.length ? ajustarZero(passantes.reduce((total, valor) => total + valor, 0) / passantes.length) : null;

    return {
      ...linha,
      astm: peneira.astm,
      abertura: peneira.abertura,
      retidaA: retidaA !== null ? numeroBR(retidaA, 1) : "",
      retidaB: retidaB !== null ? numeroBR(retidaB, 1) : "",
      passanteA: passanteA !== null ? numeroBR(passanteA, 1) : "",
      passanteB: passanteB !== null ? numeroBR(passanteB, 1) : "",
      passante: passante !== null ? numeroBR(passante, 1) : "",
    };
  });

  return { ...dados, granulometria };
}

export function limitesParaLinha(linha, faixaId) {
  const peneira = PENEIRAS_ASFALTO.find((item) => item.astm === linha.astm);
  return {
    projeto: peneira ? faixaProjeto(peneira, faixaId) : null,
    trabalho: peneira ? faixaTrabalho(peneira, faixaId, linha.passante) : null,
  };
}

function passanteLinha(material, astm) {
  const granulometria = material.granulometria || [];
  const indiceAlvo = PENEIRAS_ASFALTO.findIndex((item) => item.astm === astm);

  if (indiceAlvo < 0) return null;
  if (astm === "Fundo") return 0;

  const linhaExata = granulometria.find((item) => item.astm === astm);
  const valorExato = numero(linhaExata?.passante);
  if (valorExato !== null) return valorExato;

  // Quando uma peneira não tem valor lançado, considera que não houve retenção
  // adicional nela. Antes da primeira peneira informada, o passante é 100%.
  for (let indice = indiceAlvo - 1; indice >= 0; indice -= 1) {
    const astmAnterior = PENEIRAS_ASFALTO[indice]?.astm;
    const linhaAnterior = granulometria.find((item) => item.astm === astmAnterior);
    const valorAnterior = numero(linhaAnterior?.passante);
    if (valorAnterior !== null) return valorAnterior;
  }

  return 100;
}

function contribuicaoMescla(material, percentual, astm) {
  const passante = passanteLinha(material, astm);
  const percentualMaterial = numero(percentual) || 0;
  return passante === null ? null : passante * (percentualMaterial / 100);
}

export function calcularMescla(materiais, percentuais) {
  return PENEIRAS_ASFALTO.map((peneira) => {
    const passante = materiais.reduce((total, material, index) => {
      const contribuicao = contribuicaoMescla(material, percentuais[index], peneira.astm);
      return total + (contribuicao ?? 0);
    }, 0);
    return { astm: peneira.astm, abertura: peneira.abertura, passante };
  });
}

function pontuacaoMescla(materiais, percentuais, faixaId) {
  const mescla = calcularMescla(materiais, percentuais);
  return mescla.reduce((erro, linha) => {
    const peneira = PENEIRAS_ASFALTO.find((item) => item.astm === linha.astm);
    const faixa = peneira ? faixaProjeto(peneira, faixaId) : null;
    if (!faixa) return erro;
    if (linha.passante < faixa[0]) return erro + (faixa[0] - linha.passante) ** 2;
    if (linha.passante > faixa[1]) return erro + (linha.passante - faixa[1]) ** 2;
    return erro;
  }, 0);
}

export function normalizarPercentuais(percentuais) {
  const total = percentuais.reduce((soma, valor) => soma + valor, 0);
  if (!total) return percentuais.map(() => 0);
  return percentuais.map((valor) => (valor / total) * 100);
}

export function arredondarPercentual(valor) {
  const n = numero(valor);
  return n === null ? 0 : Number(n.toFixed(1));
}

function formatarValorFaixa(valor) {
  const n = numero(valor);
  return n === null ? "-" : numeroBR(n, 0);
}

function prioridadeMaterialMescla(material) {
  const nome = textoBusca(`${material?.material || ""} ${material?.amostra || ""} ${material?.Descricao || ""}`);
  if (/\bbrita\s*1\b/.test(nome)) return 1;
  if (/\bbrita\s*0\b/.test(nome)) return 2;
  if (nome.includes("po de pedra")) return 3;
  return 10;
}

export function percentuaisIguaisMescla(quantidade) {
  if (!quantidade) return [];
  return normalizarPercentuais(Array(quantidade).fill(100 / quantidade)).map(arredondarPercentual);
}

export function ordenarMateriaisMescla(materiais, percentuais = []) {
  const pares = (materiais || []).map((material, index) => ({
    material,
    percentual: percentuais[index],
    index,
  }));

  pares.sort((a, b) => {
    const prioridade = prioridadeMaterialMescla(a.material) - prioridadeMaterialMescla(b.material);
    if (prioridade !== 0) return prioridade;
    return String(a.material?.material || "").localeCompare(String(b.material?.material || ""), "pt-BR");
  });

  return {
    materiais: pares.map((par) => par.material),
    percentuais: pares.map((par) => par.percentual),
  };
}

export function resolverPercentuais(materiais, faixaId) {
  if (!materiais.length) return [];
  const passoInicial = materiais.length <= 3 ? 5 : 10;
  let melhor = Array(materiais.length).fill(100 / materiais.length);
  let melhorErro = pontuacaoMescla(materiais, melhor, faixaId);

  function buscar(index, restante, atual, passo) {
    if (index === materiais.length - 1) {
      const candidato = [...atual, restante];
      const erro = pontuacaoMescla(materiais, candidato, faixaId);
      if (erro < melhorErro) {
        melhorErro = erro;
        melhor = candidato;
      }
      return;
    }
    for (let valor = 0; valor <= restante; valor += passo) {
      buscar(index + 1, restante - valor, [...atual, valor], passo);
    }
  }

  buscar(0, 100, [], passoInicial);
  return melhor.map((valor) => Number(valor.toFixed(1)));
}

export function ChartGranulometriaAsfalto({ linhas, faixaId, mescla }) {
  const dados = mescla || (linhas || []).map((linha) => ({ ...linha, passante: numero(linha.passante) }));
  const peneirasGrafico = PENEIRAS_ASFALTO.filter((p) => Number.isFinite(Number(p.abertura)) && Number(p.abertura) > 0);
const aberturas = peneirasGrafico.map((p) => Number(p.abertura));
const logMin = Math.log10(Math.min(...aberturas));
const logMax = Math.log10(Math.max(...aberturas));
  const area = { left: 48, right: 620, top: 16, bottom: 182 };
  const x = (abertura) => area.left + ((Math.log10(abertura) - logMin) / (logMax - logMin)) * (area.right - area.left);
  const y = (valor) => area.bottom - Math.max(0, Math.min(100, valor)) * ((area.bottom - area.top) / 100);
  const pontos = (lista, campo) => lista.map((linha) => `${x(linha.abertura)},${y(linha[campo])}`).join(" ");
  const projetoMin = peneirasGrafico
  .map((p) => ({ abertura: p.abertura, valor: faixaProjeto(p, faixaId)?.[0] }))
  .filter((p) => p.valor !== undefined);

const projetoMax = peneirasGrafico
  .map((p) => ({ abertura: p.abertura, valor: faixaProjeto(p, faixaId)?.[1] }))
  .filter((p) => p.valor !== undefined);

const trabalhoMin = peneirasGrafico
  .map((p) => {
    const linha = dados.find((item) => item.astm === p.astm);
    const faixa = faixaTrabalho(p, faixaId, linha?.passante);
    return { abertura: p.abertura, valor: faixa?.[0] };
  })
  .filter((p) => p.valor !== undefined);

const trabalhoMax = peneirasGrafico
  .map((p) => {
    const linha = dados.find((item) => item.astm === p.astm);
    const faixa = faixaTrabalho(p, faixaId, linha?.passante);
    return { abertura: p.abertura, valor: faixa?.[1] };
  })
  .filter((p) => p.valor !== undefined);

const curva = dados.filter(
  (linha) =>
    Number.isFinite(Number(linha.abertura)) &&
    Number(linha.abertura) > 0 &&
    Number.isFinite(linha.passante)
);

  return (
    <Box sx={{ border: "1px solid #cfd8dc", p: 1, bgcolor: "#fff" }}>
      <Typography textAlign="center" fontWeight={800} fontSize={13}>Analise Granulometrica</Typography>
      <svg viewBox="0 0 660 230" style={{ width: "100%", maxHeight: 280 }}>
        {[0, 20, 40, 60, 80, 100].map((valor) => (
          <React.Fragment key={valor}>
            <line x1={area.left} x2={area.right} y1={y(valor)} y2={y(valor)} stroke="#999" strokeWidth="0.7" />
            <text x={area.left - 8} y={y(valor) + 4} textAnchor="end" fontSize="10">{valor}</text>
          </React.Fragment>
        ))}
        {peneirasGrafico.map((p) => (
          <React.Fragment key={p.astm}>
            <line x1={x(p.abertura)} x2={x(p.abertura)} y1={area.top} y2={area.bottom} stroke="#bbb" strokeWidth="0.6" />
            <text x={x(p.abertura)} y={area.bottom + 14} textAnchor="middle" fontSize="8">{p.astm}</text>
          </React.Fragment>
        ))}
        <polyline points={pontos(projetoMin, "valor")} fill="none" stroke="#00695c" strokeWidth="1.5" />
        <polyline points={pontos(projetoMax, "valor")} fill="none" stroke="#00695c" strokeWidth="1.5" />
        <polyline points={pontos(trabalhoMin, "valor")} fill="none" stroke="#0d47a1" strokeWidth="1.8" />
        <polyline points={pontos(trabalhoMax, "valor")} fill="none" stroke="#0d47a1" strokeWidth="1.8" />
       
        {curva.length > 0 && <polyline points={pontos(curva, "passante")} fill="none" stroke="#d50000" strokeDasharray="5 3" strokeWidth="1.8" />}
        <text x="24" y="102" fontSize="10" transform="rotate(-90 24 102)" textAnchor="middle">% passante</text>
<line x1="80" x2="110" y1="215" y2="215" stroke="#00695c" strokeWidth="1.5" />
<text x="114" y="218" fontSize="10">Faixa de projeto</text>

<line x1="250" x2="280" y1="215" y2="215" stroke="#0d47a1" strokeWidth="1.8" />
<text x="284" y="218" fontSize="10">Faixa de trabalho</text>

<line x1="430" x2="460" y1="215" y2="215" stroke="#d50000" strokeDasharray="5 3" strokeWidth="1.8" />
<text x="464" y="218" fontSize="10">
  {mescla ? "Granulometria da mistura" : "Amostra"}
</text>
      </svg>
    </Box>
  );
}

const estilosImpressaoMescla = `
  @page {
    size: A4 landscape;
    margin: 4mm;
  }

  html,
  body {
    width: 297mm;
    height: 210mm;
    margin: 0;
    padding: 0;
    background: #fff;
  }

  * {
    box-sizing: border-box;
    font-family: Arial, Helvetica, sans-serif;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .relatorio-mescla-print {
    width: 289mm;
    height: 202mm;
    margin: 0 auto;
    padding: 0;
    background: #fff;
    color: #000;
    overflow: hidden;
  }

  .relatorio-mescla-print .nao-imprimir {
    display: none !important;
  }

  .relatorio-mescla {
    width: 289mm !important;
    height: 202mm !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 1.5mm !important;
    background: #fff !important;
    border: 2px solid #111 !important;
    overflow: hidden !important;

    display: grid !important;
    grid-template-rows: auto auto 1fr !important;
  }

  .relatorio-mescla table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed !important;
}

  .relatorio-mescla td,
  .relatorio-mescla th {
    border: 1px solid #111 !important;
    padding: 2px 4px !important;
    font-size: 9.2px !important;
    line-height: 1.15 !important;
    text-align: center !important;
    vertical-align: middle !important;
    color: #000;
  }

  .relatorio-mescla .mescla-cabecalho td {
  height: 5.8mm !important;
  font-size: 8.8px !important;
  font-weight: 700 !important;
  padding: 1px 3px !important;
  line-height: 1.1 !important;
}

.relatorio-mescla .mescla-cabecalho tr:nth-child(1) td,
.relatorio-mescla .mescla-cabecalho tr:nth-child(2) td {
  height: 6.5mm !important;
  font-size: 10px !important;
}

.relatorio-mescla .mescla-cabecalho img {
  width: 24mm !important;
  max-height: 11mm !important;
  object-fit: contain !important;
}

.relatorio-mescla .mescla-cabecalho img {
  width: 24mm !important;
  max-height: 11mm !important;
  object-fit: contain !important;
}

  .relatorio-mescla .mescla-cabecalho img {
    width: 24mm !important;
    max-height: 10mm !important;
    object-fit: contain !important;
  }

  .relatorio-mescla .mescla-tabela-wrap {
    overflow: hidden !important;
  }

.relatorio-mescla .mescla-tabela th,
.relatorio-mescla .mescla-tabela td {
  font-size: 7.8px !important;
  padding: 1px 2px !important;
  height: 5.4mm !important;
  overflow: hidden !important;
  word-break: normal !important;
}

.relatorio-mescla .mescla-tabela thead td,
.relatorio-mescla .mescla-tabela thead th {
  white-space: normal !important;
  line-height: 1.1 !important;
}
  
 .relatorio-mescla .mescla-tabela thead th,
.relatorio-mescla .mescla-tabela thead td {
  font-size: 8px !important;
  font-weight: 700 !important;
  height: 6mm !important;
}

  .relatorio-mescla .mescla-rodape {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 1.5mm !important;
    margin-top: 1.5mm !important;
    min-height: 78mm !important;
  }

  .relatorio-mescla .mescla-observacao,
  .relatorio-mescla .mescla-grafico {
    border: 1px solid #111 !important;
    height: 100% !important;
    min-height: 78mm !important;
    padding: 2mm !important;
    background: #fff !important;
    overflow: hidden !important;
    font-size: 9.5px !important;
    line-height: 1.22 !important;
  }

  .relatorio-mescla .mescla-observacao {
    text-align: left !important;
    white-space: pre-line !important;
  }

  .relatorio-mescla svg {
    width: 100% !important;
    height: 69mm !important;
    max-height: 69mm !important;
  }

  .relatorio-mescla .mescla-grafico p,
  .relatorio-mescla .mescla-grafico h6,
  .relatorio-mescla .mescla-grafico .MuiTypography-root {
    font-size: 9px !important;
    font-weight: 700 !important;
    text-align: center !important;
  }
`;

function imprimirRelatorioMescla(codigo) {
  const conteudo = document.querySelector(".relatorio-mescla");
  if (!conteudo) return;

  const janela = window.open("", "_blank", "width=1200,height=800");

  if (!janela) {
    alert("Permita pop-ups para imprimir a mescla granulometrica.");
    return;
  }

  janela.document.write(`
    <html>
      <head>
        <title>${String(codigo || "Mescla Granulometrica")}</title>
        <base href="${window.location.origin}/" />
        <style>${estilosImpressaoMescla}</style>
      </head>
      <body>
        <div class="relatorio-mescla-print">
          ${conteudo.outerHTML}
        </div>
        <script>
          window.onload = async function () {
            const imagens = Array.from(document.images);
            await Promise.all(imagens.map(function (imagem) {
              if (imagem.complete) return Promise.resolve();
              return new Promise(function (resolve) {
                imagem.onload = resolve;
                imagem.onerror = resolve;
              });
            }));
            window.focus();
            window.print();
            window.close();
          };
        </script>
      </body>
    </html>
  `);

  janela.document.close();
}

export function RelatorioMescla({ dados, onVoltar, autoPrint = false, onReady, modoAnexo = false }) {
  useEffect(() => {
    onReady?.();
  }, [onReady]);

  useEffect(() => {
    if (!autoPrint) return undefined;
    const frame = window.requestAnimationFrame(() => imprimirRelatorioMescla(dados?.codigo));
    return () => window.cancelAnimationFrame(frame);
  }, [autoPrint]);

  const materiais = dados.materiais || [];
  const percentuais = dados.percentuais || [];
  const mescla = calcularMescla(materiais, percentuais);
  const componentesMescla = Array.from({ length: 5 }, (_, index) => ({
  material: materiais[index] || null,
  percentual: percentuais[index],
  index,
}));


  return (
    <Box className="relatorio-mescla-print" sx={modoAnexo ? { bgcolor: "#fff" } : { p: 2, bgcolor: "#e5e5e5", minHeight: "100vh" }}>
      {!modoAnexo && <style>{`
        @page { size: A4 landscape; margin: 0; }
        @media print {
          html, body { width: 297mm; height: 210mm; margin: 0 !important; padding: 0 !important; background: #fff !important; }
          body * { visibility: hidden; }
          .relatorio-mescla, .relatorio-mescla * { visibility: visible; }
          .relatorio-mescla {
            box-sizing: border-box !important;
            left: 0 !important;
            margin: 0 !important;
            max-width: none !important;
            min-height: 210mm !important;
            position: absolute !important;
            top: 0 !important;
            width: 297mm !important;
          }
          .nao-imprimir { display:none !important; }
        }
      `}</style>}
      {modoAnexo && <style>{`
        @page relatorioMesclaAnexoPrint { size: A4 landscape; margin: 0; }
        @media print {
          .relatorio-anexo-mescla,
          .relatorio-anexo-mescla > .MuiBox-root {
            box-sizing: border-box !important;
            height: 210mm !important;
            margin: 0 !important;
            min-height: 210mm !important;
            overflow: hidden !important;
            padding: 0 !important;
            page: relatorioMesclaAnexoPrint !important;
            width: 297mm !important;
          }

          .relatorio-anexo-mescla .relatorio-mescla {
            box-sizing: border-box !important;
            height: 210mm !important;
            page: relatorioMesclaAnexoPrint;
            margin: 0 !important;
            max-width: none !important;
            min-height: 210mm !important;
            padding: 1.5mm !important;
            width: 297mm !important;
          }
        }
      `}</style>}
      {!modoAnexo && <Stack direction="row" spacing={1} mb={2} className="nao-imprimir">
        <Button variant="outlined" onClick={onVoltar}>Voltar</Button>
        <Button variant="contained" onClick={() => imprimirRelatorioMescla(dados?.codigo)}>Imprimir</Button>
      </Stack>}
      <Box
          className="relatorio-mescla"
          sx={{
            bgcolor: "#fff",
            border: "2px solid #111",
            maxWidth: 1120,
            mx: "auto",
            p: 0.5,
            width: "100%",
            minHeight: 760,
          }}
        >
        <Table
  className="mescla-cabecalho"
  size="small"
  sx={{
    "& td, & th": {
      border: "1px solid #111",
      p: "2px 4px",
      fontSize: 12,
      lineHeight: 1.15,
    },
  }}
>
  <TableBody>
    <TableRow>
      <TableCell
        rowSpan={2}
        sx={{
          width: 100,
          bgcolor: "#fff",
          textAlign: "center",
          verticalAlign: "middle",
        }}
      >
        <LogoRelatorio
          alt="Logo"
          style={{
            width: 88,
            maxHeight: 36,
            objectFit: "contain",
          }}
         />
      </TableCell>

      <TableCell
        align="center"
        colSpan={10}
        sx={{
          fontWeight: 900,
          fontSize: "13px !important",
          height: 24,
        }}
      >
        SISTEMA DE GESTÃO DA QUALIDADE
      </TableCell>
    </TableRow>

    <TableRow>
      <TableCell
        align="center"
        colSpan={10}
        sx={{
          fontWeight: 900,
          fontSize: "13px !important",
          height: 24,
        }}
      >
        MESCLA GRANULOMÉTRICA DE AGREGADOS
      </TableCell>
    </TableRow>

    <TableRow>
      <TableCell
        colSpan={11}
        sx={{
          height: 24,
          textAlign: "left !important",
          pl: "24px !important",
        }}
      >
        CLIENTE: {dados.cliente || ""}
      </TableCell>
    </TableRow>

    <TableRow>
      <TableCell
        colSpan={11}
        sx={{
          height: 24,
          textAlign: "left !important",
          pl: "32px !important",
        }}
      >
        OBRA: {dados.obra || ""}
      </TableCell>
    </TableRow>
  </TableBody>
</Table>
        <Box className="mescla-tabela-wrap" sx={{ overflowX: "auto" }}>
 <Table
  className="mescla-tabela"
  size="small"
  sx={{
    tableLayout: "fixed",
    width: "100%",
    "& td, & th": {
      border: "1px solid #111",
      p: "2px 4px",
      fontSize: 11,
      textAlign: "center",
      verticalAlign: "middle",
    },
  }}
>
  <colgroup>
    <col style={{ width: "5%" }} />
    <col style={{ width: "4%" }} />

    <col style={{ width: "10%" }} />
    <col style={{ width: "10%" }} />
    <col style={{ width: "10%" }} />
    <col style={{ width: "10%" }} />
    <col style={{ width: "10%" }} />

    <col style={{ width: "11%" }} />

    <col style={{ width: "5%" }} />
    <col style={{ width: "5%" }} />

    <col style={{ width: "5%" }} />
    <col style={{ width: "5%" }} />

    <col style={{ width: "5%" }} />
    <col style={{ width: "5%" }} />
  </colgroup>
            <TableHead>
            
            <TableRow>
  <TableCell colSpan={2}>Peneiras</TableCell>
  <TableCell colSpan={5}>Componentes</TableCell>
  <TableCell rowSpan={2}>Granulometria da Mistura</TableCell>
  <TableCell colSpan={2}>Faixa de Trabalho</TableCell>
  <TableCell colSpan={2}>DNIT 031 - 2024 ES</TableCell>
  <TableCell colSpan={2}>Verificação Total</TableCell>
</TableRow>

<TableRow>
  <TableCell>Pol./Nº</TableCell>
  <TableCell>mm</TableCell>

  {componentesMescla.map(({ material, percentual, index }) => (
    <TableCell key={material?.id || `componente-vazio-${index}`}>
      {material ? material.material || material.amostra || `Comp. ${index + 1}` : "-"}
      <br />
      {material ? `${numeroBR(percentual, 1)}%` : "-"}
    </TableCell>
  ))}

  <TableCell>Min.</TableCell>
  <TableCell>Max.</TableCell>

  <TableCell>Min.</TableCell>
  <TableCell>Max.</TableCell>

  <TableCell>Min.</TableCell>
  <TableCell>Max.</TableCell>
</TableRow>
            </TableHead>
            <TableBody>
              {PENEIRAS_ASFALTO.map((peneira, index) => {
                const projeto = faixaProjeto(peneira, dados.faixa);
                const trabalho = faixaTrabalho(peneira, dados.faixa, mescla[index]?.passante);
                return (
                  <TableRow key={peneira.astm}>
                    <TableCell>{peneira.astm}</TableCell>
                    <TableCell>
                      {peneira.abertura === null || peneira.abertura === undefined || peneira.abertura === ""
                        ? "-"
                        : String(peneira.abertura).replace(".", ",")}
                    </TableCell>
                   {componentesMescla.map(({ material, percentual, index }) => (
  <TableCell key={material?.id || `componente-vazio-linha-${index}`}>
    {material ? numeroBR(contribuicaoMescla(material, percentual, peneira.astm), 1) || "0,0" : ""}
  </TableCell>
))}
                    <TableCell sx={{ color: "#d00", fontWeight: 800 }}>
  {numeroBR(mescla[index]?.passante, 1)}
</TableCell>

<TableCell sx={{ color: "#0d47a1" }}>
  {formatarValorFaixa(trabalho?.[0])}
</TableCell>

<TableCell sx={{ color: "#0d47a1" }}>
  {formatarValorFaixa(trabalho?.[1])}
</TableCell>

<TableCell sx={{ color: "#087a2f" }}>
  {formatarValorFaixa(projeto?.[0])}
</TableCell>

<TableCell sx={{ color: "#087a2f" }}>
  {formatarValorFaixa(projeto?.[1])}
</TableCell>

<TableCell sx={{ fontWeight: 700 }}>
  {trabalho && mescla[index]?.passante >= trabalho[0] ? "ok" : "-"}
</TableCell>

<TableCell sx={{ fontWeight: 700 }}>
  {trabalho && mescla[index]?.passante <= trabalho[1] ? "ok" : "-"}
</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
       <Box
          className="mescla-rodape"
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 1,
            mt: 0.5,
            minHeight: 300,
          }}
        >
         <Box
            className="mescla-observacao"
            sx={{
              minHeight: 300,
              border: "1px solid #111",
              p: 1,
              fontSize: 12,
              whiteSpace: "pre-line",
            }}
          >
            <strong>OBSERVACAO:</strong>
            <br />
            {`FAIXA UTILIZADA: ${FAIXAS.find((faixa) => faixa.id === dados.faixa)?.label || dados.faixa || "-"} — DNIT 031/2024 - ES`}
            <br />
            {dados.observacoes || materiais.map((m) => `${m.material || m.amostra || "-"} - ${m.procedencia || ""}`).join("\n")}
          </Box>
          <Box className="mescla-grafico">
            <ChartGranulometriaAsfalto faixaId={dados.faixa} mescla={mescla} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default function CadastroGranulometriaAsfalto() {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();
  const history = useHistory();
  const [ensaios, setEnsaios] = useState([]);
  const [carregandoLista, setCarregandoLista] = useState(true);
  const [materiaisCadastrados, setMateriaisCadastrados] = useState([]);
  const [obras, setObras] = useState([]);
  const [form, setForm] = useState(estadoInicial);
  const [dialogAberto, setDialogAberto] = useState(false);
  const [itemEditando, setItemEditando] = useState(null);
  const [filtro, setFiltro] = useState("");

  useEffect(() => {
    carregarEnsaios();
    carregarMateriaisCadastrados();
    carregarObras();
  }, []);

  async function carregarEnsaios() {
    const snap = await getDocs(consultaTenantAtual(query(collection(db, COLECAO), orderBy("criadoEm", "desc"))));
    setEnsaios(snap.docs.map((documento) => ({ id: documento.id, ...documento.data() })));
    setCarregandoLista(false);
  }

  async function carregarMateriaisCadastrados() {
    const snap = await getDocs(consultaTenantAtual(query(collection(db, "tblListaMateriaisCadastrados"), orderBy("codigo", "desc"))));
    setMateriaisCadastrados(snap.docs.map((documento) => ({ id: documento.id, ...documento.data() })));
  }

  async function carregarObras() {
    const snap = await getDocs(consultaTenantAtual(collection(db, "obras")));
    setObras(snap.docs.map((documento) => ({ id: documento.id, ...documento.data() })));
  }

  function abrirNovo() {
    setItemEditando(null);
    setForm({ ...estadoInicial, codigo: String(ensaios.length + 1).padStart(3, "0"), granulometria: estadoInicial.granulometria.map((l) => ({ ...l })) });
    setDialogAberto(true);
  }

  function abrirEdicao(item) {
    setItemEditando(item);
    setForm(
      recalcularGranulometria({
        ...estadoInicial,
        ...item,
        granulometria: PENEIRAS_ASFALTO.map((peneira, index) => ({
          ...estadoInicial.granulometria[index],
          ...(item.granulometria?.[index] || {}),
          astm: peneira.astm,
          abertura: peneira.abertura,
        })),
      })
    );
    setDialogAberto(true);
  }

  function atualizarCampo(campo, valor) {
    setForm((atual) => recalcularGranulometria({ ...atual, [campo]: valor }));
  }

  function selecionarCliente(cliente) {
    setForm((atual) =>
      recalcularGranulometria({
        ...atual,
        cliente: cliente || "",
        obra: "",
        obraId: "",
        material: "",
        materialId: "",
        codigoMaterial: "",
      })
    );
  }

  function selecionarObra(nomeObra) {
    const obraSelecionada = obras.find((obra) => obra.nome === nomeObra);
    setForm((atual) =>
      recalcularGranulometria({
        ...atual,
        obra: nomeObra || "",
        obraId: obraSelecionada?.id || "",
        material: "",
        materialId: "",
        codigoMaterial: "",
      })
    );
  }

  function selecionarMaterialCadastrado(material) {
    const obraEncontrada = obras.find((obra) => obra.id === material?.ObraId);

    setForm((atual) =>
      recalcularGranulometria({
        ...atual,
        cliente: material?.Cliente || atual.cliente || "",
        obra: obraEncontrada?.nome || atual.obra || "",
        obraId: material?.ObraId || atual.obraId || "",
        material: material?.Descricao || "",
        materialId: material?.id || "",
        codigoMaterial: material?.codigo || "",
        procedencia: material?.Fornecedor || atual.procedencia || "",
        localColeta: material?.LocalColeta || atual.localColeta || "",
      })
    );
  }

  function atualizarLinha(index, campo, valor) {
    setForm((atual) => recalcularGranulometria({
      ...atual,
      granulometria: atual.granulometria.map((linha, linhaIndex) => linhaIndex === index ? { ...linha, [campo]: valor } : linha),
    }));
  }

  async function salvar() {
    if (!form.material) {
      alert("Informe o material.");
      return;
    }
    const dados = recalcularGranulometria({ ...form, atualizadoEm: new Date() });
    let granulometriaId = itemEditando?.id || "";
    if (itemEditando?.id) {
      await updateDoc(doc(db, COLECAO, itemEditando.id), dados);
      setDialogAberto(false);
      setItemEditando(null);
      await carregarEnsaios();
      return;
    } else {
      const novo = await addDoc(collection(db, COLECAO), aplicarTenantAtual({ ...dados, criadoEm: new Date() }));
      granulometriaId = novo.id;
    }
    setDialogAberto(false);
    if (granulometriaId) {
      history.push(`/app/granulometria-asfalto/${granulometriaId}`);
      return;
    }
    await carregarEnsaios();
  }

  const listaFiltrada = useMemo(() => {
    const termo = filtro.trim().toLowerCase();
    const ensaiosBase = ensaios.filter((item) => item.tipo !== "mescla");
    if (!termo) return ensaiosBase;
    return ensaiosBase.filter((item) => contemTextoPesquisa([item.codigo, item.cliente, item.obra, item.material, item.codigoMaterial, item.procedencia].join(" ").toLowerCase(), termo));
  }, [ensaios, filtro]);

  const clientesCadastrados = useMemo(() => {
    return Array.from(new Set(materiaisCadastrados.map((item) => item.Cliente).filter(Boolean))).sort((a, b) =>
      String(a).localeCompare(String(b), "pt-BR")
    );
  }, [materiaisCadastrados]);

  const obrasFiltradas = useMemo(() => {
    const cliente = textoBusca(form.cliente);
    const obrasIds = cliente
      ? new Set(
          materiaisCadastrados
            .filter((material) => textoBusca(material.Cliente) === cliente)
            .map((material) => material.ObraId)
            .filter(Boolean)
        )
      : null;

    return obras
      .filter((obra) => !obrasIds || obrasIds.has(obra.id))
      .sort((a, b) => String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR"));
  }, [form.cliente, materiaisCadastrados, obras]);

  const materiaisFiltrados = useMemo(() => {
    const cliente = textoBusca(form.cliente);
    const obraId = form.obraId;
    const obra = textoBusca(form.obra);

    return materiaisCadastrados.filter((material) => {
      const obraMaterial = obras.find((item) => item.id === material.ObraId);
      const clienteConfere = !cliente || textoBusca(material.Cliente) === cliente;
      const obraConfere = obraId
        ? material.ObraId === obraId
        : !obra || textoBusca(obraMaterial?.nome) === obra;
      return clienteConfere && obraConfere;
    });
  }, [form.cliente, form.obra, form.obraId, materiaisCadastrados, obras]);

  return (
    <>
      <Navbar />
      <Box sx={{ p: { xs: 2, md: 4 }, mt: 6 }}>
        <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" spacing={2} mb={2}>
          <Box>
            <Typography variant="h5" fontWeight={900}>Granulometria de Asfalto</Typography>
            <Typography color="text.secondary">DNIT 031/2024 - ES, faixas A-25, B-19, C-12,5 e D-9,5.</Typography>
          </Box>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
            <Button startIcon={<ScienceIcon />} variant="outlined" onClick={() => history.push("/app/relatorios/mescla-granulometrica")}>
              Relatórios Mescla Granulométrica
            </Button>
            <Button startIcon={<AddIcon />} variant="contained" onClick={abrirNovo}>Novo ensaio</Button>
          </Stack>
        </Stack>
        <TextField size="small" label="Pesquisar" value={filtro} onChange={(event) => setFiltro(event.target.value)} fullWidth sx={{ mb: 2 }} />
        </Paper>
        <Paper sx={{ borderRadius: "8px", overflow: "auto", border: "1px solid #e2e8f0", boxShadow: "none" }}>
          <Table className="lista-cadastro-padrao" size="small" sx={{ minWidth: 900 }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell><strong>Codigo</strong></TableCell>
                <TableCell>Data</TableCell>
                <TableCell>Cliente / Obra</TableCell>
                <TableCell>Material / Procedencia</TableCell>
                <TableCell>Faixa</TableCell>
                <TableCell align="center">Acoes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listaFiltrada.map((item) => (
                <TableRow
                  key={item.id}
                  hover
                  onClick={() => history.push(`/app/granulometria-asfalto/${item.id}`)}
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell>{item.codigo || "-"}</TableCell>
                  <TableCell>
                    <Typography component="span" variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                      {formatarDataBR(item.data)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Stack spacing={0.25}>
                      <Typography component="span" variant="body2" sx={{ color: "#0f2f5f", fontWeight: 700 }}>
                        {item.cliente || "-"}
                      </Typography>
                      <Typography component="span" variant="caption" sx={{ color: "#475569", fontWeight: 600 }}>
                        {item.obra || "-"}
                      </Typography>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Stack spacing={0.25}>
                      <Typography component="span" variant="body2" sx={{ color: "#14532d", fontWeight: 700 }}>
                        {`${item.codigoMaterial ? `COD. ${item.codigoMaterial} - ` : ""}${item.material || "-"}`}
                      </Typography>
                      <Typography component="span" variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                        {item.procedencia || "-"}
                      </Typography>
                    </Stack>
                  </TableCell>
                  <TableCell><Chip size="small" label={FAIXAS.find((f) => f.id === item.faixa)?.label || item.faixa} /></TableCell>
                  <TableCell align="center">
                    <Tooltip title="Editar">
                      <IconButton
                        onClick={(event) => {
                          event.stopPropagation();
                          abrirEdicao(item);
                        }}
                      >
                        <EditIcon sx={{ color: "#0288d1" }} />
                      </IconButton>
                    </Tooltip>
                    <HistoricoCadastro colecao={COLECAO} documentoId={item.id} registro={item} />
                  </TableCell>
                </TableRow>
              ))}
              {carregandoLista && <TableRow><TableCell colSpan={6}><Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}><CircularProgress /><Typography color="text.secondary">Carregando registros...</Typography></Box></TableCell></TableRow>}
              {!carregandoLista && !listaFiltrada.length && <TableRow><TableCell colSpan={6} align="center">Nenhum ensaio cadastrado.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Paper>
      </Box>

      <Dialog open={dialogAberto} onClose={() => !salvandoCadastro && setDialogAberto(false)} fullWidth maxWidth="md">
        <DialogTitle>{itemEditando ? "Editar granulometria de asfalto" : "Nova granulometria de asfalto"}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" }, gap: 2 }}>
              <TextField label="Codigo" value={form.codigo} onChange={(e) => atualizarCampo("codigo", e.target.value)} size="small" />
              <TextField type="date" label="Data" value={form.data} onChange={(e) => atualizarCampo("data", e.target.value)} InputLabelProps={{ shrink: true }} size="small" />
              <TextField select label="Faixa DNIT" value={form.faixa} onChange={(e) => atualizarCampo("faixa", e.target.value)} size="small">
                {FAIXAS.map((faixa) => <MenuItem key={faixa.id} value={faixa.id}>{faixa.label}</MenuItem>)}
              </TextField>
              <TextField label="Operador" value={form.operador} onChange={(e) => atualizarCampo("operador", e.target.value)} size="small" />
              <Autocomplete
                freeSolo
                options={clientesCadastrados}
                value={form.cliente || ""}
                sx={{ gridColumn: "1 / -1" }}
                onChange={(event, value) => selecionarCliente(value || "")}
                onInputChange={(event, value) => {
                  if (value !== form.cliente) selecionarCliente(value || "");
                }}
                renderInput={(params) => <TextField {...params} label="Cliente" size="small" />}
              />
              <Autocomplete
                freeSolo
                options={obrasFiltradas.map((obra) => obra.nome).filter(Boolean)}
                value={form.obra || ""}
                sx={{ gridColumn: "1 / -1" }}
                onChange={(event, value) => selecionarObra(value || "")}
                onInputChange={(event, value) => {
                  if (value !== form.obra) selecionarObra(value || "");
                }}
                renderInput={(params) => <TextField {...params} label="Obra" size="small" />}
              />
              <Autocomplete
                options={materiaisFiltrados}
                sx={{ gridColumn: "1 / -1" }}
                getOptionLabel={(option) =>
                  option
                    ? `${option.codigo || ""} - ${option.Descricao || ""} - ${option.Fornecedor || ""}`
                    : ""
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={materiaisCadastrados.find((material) => material.id === form.materialId) || null}
                onChange={(event, value) => selecionarMaterialCadastrado(value)}
                renderInput={(params) => <TextField {...params} label="Material" size="small" />}
              />
              <TextField label="Procedencia" value={form.procedencia} onChange={(e) => atualizarCampo("procedencia", e.target.value)} size="small" />
              <TextField label="Local da coleta" value={form.localColeta} onChange={(e) => atualizarCampo("localColeta", e.target.value)} size="small" />
            </Box>
            <TextField label="Observacoes" value={form.observacoes} onChange={(e) => atualizarCampo("observacoes", e.target.value)} multiline minRows={2} fullWidth />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogAberto(false)} disabled={salvandoCadastro}>Cancelar</Button>
          <Button variant="contained" onClick={() => executarSalvamento(salvar)} disabled={salvandoCadastro}>
            {salvandoCadastro ? "Salvando..." : itemEditando ? "Salvar" : "Salvar e abrir"}
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}
